
export enum HotspotIds {
    FILE_UPLOAD_BUTTON = 'file_upload_button',
    RECOMMENDED_HEADER_MAPPING = 'recommended_header_mapping',
    SAMPLE_FILES_DOWNLOAD = 'sample_files_download',
    SELECT_SHEET_HEADER = 'select_sheet_header',
    WIZARD_NEXT_BUTTON = 'wizard_next_button'
}

export function getIndexedId(hotspotId: string, index: number) {
    return `${hotspotId}-${index}`;
}
